"use strict"

import React from "react"
import { Tab, Tabs } from "react-bootstrap"

import { PageTitle } from "../../config/AppSettingsConfigProvider"
import SourceRegistration from "./SourceRegistration"

export default function SourceRegistrationDash({ intl }) {
  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle
          glyph={"check-square-o"}
          id={"navigation.source.registration"}
          description={"Source Registration"}
        />
        <div>
          <Tabs
            defaultActiveKey={"reactorManagement"}
            id={"reactor-management-tabs"}
            className={"full-height"}
          >
            <Tab
              eventKey={"reactorManagement"}
              title={intl.formatMessage({
                id: "sourceregistration.reactor.management",
                defaultMessage: "Reactor Management",
              })}
              key={"reactorManagement"}
            >
              <div className={"tab-body"}>
                <SourceRegistration
                  type={"reactor"}
                  translation_ids={{
                    register_new: "general.register.reactor",
                    type: "general.reactor",
                  }}
                />
              </div>
            </Tab>
            <Tab
              eventKey={"systemManagement"}
              title={intl.formatMessage({
                id: "sourceregistration.system.management",
                defaultMessage: "System Management",
              })}
              key={"systemManagement"}
            >
              <div className={"tab-body"}>
                <SourceRegistration
                  type={"system"}
                  translation_ids={{
                    register_new: "general.register.system",
                    type: "general.system",
                  }}
                />
              </div>
            </Tab>
            <Tab
              eventKey={"methodManagement"}
              title={intl.formatMessage({
                id: "sourceregistration.method.management",
                defaultMessage: "Method Management",
              })}
              key={"methodManagement"}
            >
              <div className={"tab-body"}>
                <SourceRegistration
                  type={"analyticalmethod"}
                  translation_ids={{
                    register_new: "general.register.method",
                    type: "general.analytical.method",
                  }}
                  hideDCSTables
                />
              </div>
            </Tab>
            <Tab
              eventKey={"nsRecipeManagement"}
              title={intl.formatMessage({
                id: "sourceregistration.ns.recipe.management",
                defaultMessage: "NS Recipe Management",
              })}
              key={"nsRecipeManagement"}
            >
              <div className={"tab-body"}>
                <SourceRegistration
                  type={"nsrecipe"}
                  translation_ids={{
                    register_new: "general.register.ns.recipe",
                    type: "general.ns.recipe",
                  }}
                  hideDCSTables
                />
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  )
}
